export const baseDevicesUrl = '/user-manager/api';
